import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/crmContatti';
import { selectors, DEFAULT_STATE } from '../reducers/crmContatti';
import api from '../apis/crmContatti';

const sagas = helper.createSagas('crmContatti', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];